<template>
  <!-- 分页 -->
  <Page class="list_page"
        :current="params.pageNum"
        :page-size="params.pageSize"
        :total="total"
        :show-total="true"
        show-elevator
        show-sizer
        prev-text="<<上一页"
        next-text="下一页>>"
        @on-change="changePage"
        @on-page-size-change="changePageSize"/>
</template>

<script>
  export default {
    name: 'index',
    props: {
      total: Number
    },
    data() {
      return {
        params: {
          pageNum: 1,
          pageSize: 30
        }
      }
    },
    methods: {
      changePage (index) {
        console.log(1,index)
        this.params.pageNum = index
        this.$emit('changePage',this.params )
      },
      changePageSize(value){
        console.log(1,value)
        this.params.pageSize = value
        if(this.params.pageNum == 1) {
          this.$emit('changePage', this.params)
        }

      }
    }
  }
</script>

<style scoped>

</style>
